import { createPagination } from './pagination'

export default {
  namespaced: true,
  modules: {
    news: createPagination(),
    user: createPagination(),
    team: createPagination(),
    questionnaire: createPagination(),
    questionCategory: createPagination(),
    question: createPagination()
  }
}
